import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Results = ({ user, onLogout }) => {
  const [results, setResults] = useState([]);
  const [usersNotVoted, setUsersNotVoted] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    try {
      const response = await api.get('/results');
      setResults(response.data.results || []);
      setUsersNotVoted(response.data.usersNotVoted || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Error loading results');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: 'white',
        fontSize: '1.5rem'
      }}>
        Loading results...
      </div>
    );
  }

  const maxCredits = results.length > 0 ? Math.max(...results.map(r => r.totalCredits)) : 0;

  return (
    <div style={{
      minHeight: '100vh',
      padding: '40px 20px',
      color: 'white'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div>
            <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>
              Voting Results
            </h1>
            <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>
              Admin: {user.username}
            </p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={loadResults}
              style={{
                padding: '10px 20px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid white',
                borderRadius: '12px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Refresh
            </button>
            <button
              onClick={onLogout}
              style={{
                padding: '10px 20px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid white',
                borderRadius: '12px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Logout
            </button>
          </div>
        </div>

        {error && (
          <div style={{
            backgroundColor: 'rgba(244, 67, 54, 0.9)',
            color: 'white',
            padding: '15px',
            borderRadius: '12px',
            marginBottom: '30px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Top 3 Podium */}
        {results.length > 0 && (
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              🏆 Top 3
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px',
              marginBottom: '40px'
            }}>
              {results.slice(0, 3).map((result, index) => (
                <div
                  key={result.group.id}
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    borderRadius: '20px',
                    padding: '25px',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                    color: '#333',
                    border: index === 0 && maxCredits > 0 ? '3px solid #FF6600' : index === 1 ? '3px solid #C0C0C0' : index === 2 ? '3px solid #CD7F32' : 'none',
                    position: 'relative'
                  }}
                >
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    color: index === 0 ? '#FF6600' : index === 1 ? '#C0C0C0' : '#CD7F32'
                  }}>
                    {index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'}
                  </div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    marginBottom: '15px'
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '60px',
                      height: '60px'
                    }}>
                      {result.group.logo && result.group.logo.startsWith('/') ? (
                        <img 
                          src={result.group.logo} 
                          alt={result.group.name}
                          style={{
                            maxWidth: '60px',
                            maxHeight: '60px',
                            objectFit: 'contain'
                          }}
                        />
                      ) : (
                        <span style={{ fontSize: '3rem' }}>{result.group.logo || '📦'}</span>
                      )}
                    </div>
                    <div>
                      <h3 style={{
                        fontSize: '1.3rem',
                        color: '#4169E1',
                        marginBottom: '5px'
                      }}>
                        {result.group.name}
                      </h3>
                      <span style={{
                        backgroundColor: index === 0 ? '#FF6600' : index === 1 ? '#C0C0C0' : '#CD7F32',
                        color: 'white',
                        padding: '3px 10px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold'
                      }}>
                        {index === 0 ? '🏆 WINNER' : `#${index + 1}`}
                      </span>
                    </div>
                  </div>
                  <p style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    marginBottom: '20px'
                  }}>
                    {result.group.description}
                  </p>
                  <div style={{
                    backgroundColor: '#f5f5f5',
                    padding: '15px',
                    borderRadius: '12px'
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '10px'
                    }}>
                      <span style={{ fontWeight: '600' }}>Total Credits:</span>
                      <span style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#4169E1' }}>
                        {result.totalCredits}
                      </span>
                    </div>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}>
                      <span style={{ fontWeight: '600' }}>Number of Votes:</span>
                      <span style={{ fontSize: '1.1rem', color: '#666' }}>
                        {result.voteCount}
                      </span>
                    </div>
                    {maxCredits > 0 && (
                      <div style={{ marginTop: '10px' }}>
                        <div style={{
                          width: '100%',
                          height: '8px',
                          backgroundColor: '#e0e0e0',
                          borderRadius: '8px',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            width: `${(result.totalCredits / maxCredits) * 100}%`,
                            height: '100%',
                            backgroundColor: '#4169E1',
                            transition: 'width 0.3s ease'
                          }} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Other Groups */}
        {results.length > 3 && (
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              Other Groups
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '15px'
            }}>
              {results.slice(3).map((result, index) => (
                <div
                  key={result.group.id}
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    borderRadius: '12px',
                    padding: '15px',
                    boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px',
                    height: '50px'
                  }}>
                    {result.group.logo && result.group.logo.startsWith('/') ? (
                      <img 
                        src={result.group.logo} 
                        alt={result.group.name}
                        style={{
                          maxWidth: '50px',
                          maxHeight: '50px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <span style={{ fontSize: '2rem' }}>{result.group.logo || '📦'}</span>
                    )}
                  </div>
                  <h4 style={{
                    fontSize: '1rem',
                    color: '#4169E1',
                    marginBottom: '8px',
                    fontWeight: '600'
                  }}>
                    {result.group.name}
                  </h4>
                  <div style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: '#4169E1'
                  }}>
                    {result.voteCount} {result.voteCount === 1 ? 'vote' : 'votes'}
                  </div>
                  <div style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    marginTop: '5px'
                  }}>
                    {result.totalCredits} credits
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Users who haven't voted */}
        {usersNotVoted.length > 0 && (
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              Users Who Haven't Voted
            </h2>
            <div style={{
              backgroundColor: 'rgba(255,255,255,0.95)',
              borderRadius: '20px',
              padding: '25px'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '15px'
              }}>
                {usersNotVoted.map((user, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: '#f5f5f5',
                      borderRadius: '12px',
                      padding: '15px',
                      textAlign: 'center',
                      position: 'relative'
                    }}
                  >
                    {user.isAdmin && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        backgroundColor: '#FF6600',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        fontWeight: 'bold'
                      }}>
                        ADMIN
                      </div>
                    )}
                    <div style={{
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      color: '#333',
                      marginBottom: '5px'
                    }}>
                      {user.username}
                    </div>
                    {user.groupName ? (
                      <div style={{
                        fontSize: '0.85rem',
                        color: '#666'
                      }}>
                        {user.groupName}
                      </div>
                    ) : user.isAdmin && (
                      <div style={{
                        fontSize: '0.85rem',
                        color: '#666',
                        fontStyle: 'italic'
                      }}>
                        No group
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {results.length === 0 && usersNotVoted.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            backgroundColor: 'rgba(255,255,255,0.95)',
            borderRadius: '20px',
            color: '#666'
          }}>
            <p style={{ fontSize: '1.2rem' }}>
              No votes registered yet.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Results;

